import { usePluginMessages } from '../../../composition/plugin-runtime';
import { useCheckout } from '../composition/use-checkout';

export interface PayWidgetProps {
  readonly platformUrl: string;
  readonly product: string;
}

export function PayWidget({ platformUrl, product }: PayWidgetProps) {
  const t = usePluginMessages('pay');
  const { signedIn, back, busy, error, buy } = useCheckout(platformUrl, product);
  return (
    <section aria-label={t('label')}>
      {back && <p role="status">{t(`status.${back.status}`)}</p>}
      {signedIn ? (
        <button type="button" onClick={() => void buy()} disabled={busy}>
          {t('buy')}
        </button>
      ) : (
        <p>{t('needLogin')}</p>
      )}
      {error && <p role="alert">{t(`error.${error}`)}</p>}
    </section>
  );
}

/** 슬롯은 props 없는 컴포넌트를 받는다 — 플러그인 설정을 묶어 넘긴다 */
export function payWidget(props: PayWidgetProps) {
  return function BoundPayWidget() {
    return <PayWidget {...props} />;
  };
}
